import React, { useEffect, useState } from "react";
import { Input, LabelText, Text, FlexContainer, InputWrapper } from "../../design";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import { ErrorMessage } from "@hookform/error-message";

type Props = {
  control: any,
  errors: any,
  alpha2: String,
  metaInfo: Object,
}

const MetaData = (props: Props) => {
  const { control, errors, alpha2, metaInfo } = props;
  const [category, setCategory] = useState([]);

  useEffect(() => {
    if (metaInfo && metaInfo.seatPageMetaTickets && metaInfo.seatPageMetaTickets.length !== 0) {
      const meta = metaInfo.seatPageMetaTickets;
      const categ = meta.filter((item) => item.type !== 'TICKET');
      setCategory(categ);
    }
  }, [metaInfo]);

  const getByLabelText = (type) => {
    if (type === 'INPUT_ALPHA_NUMERIC') {
      return 'Alpha Numeric';
    } if (type === 'INPUT_NUMBER') {
      return 'Number';
    } if (type === 'INPUT_SINGLE_LINE_TEXT') {
      return 'Single Line Text';
    }
    if (type === 'INPUT_EMAIL') {
      return 'Email';
    }
    if (type === "INPUT_PHONE") {
      return 'Phone Number';
    }
    return null;
  };

  const OnInput = event => {
    event.target.value = event.target.value.replace(/[^A-Za-z0-9 ]/g, '')
  };

  return (
    <>
      {
        category && category.length !== 0 && (
          <>
            {
              category.map((data) => (
                <>
                {
                  data.type !== "PROMOTIONAL_CODES" && (
                    <div class="row">
                  <div class="col-sm">
                    <LabelText style={{ marginBottom: '8px' }}>
                      {data.name ? data.name : getByLabelText(data.type)}
                    </LabelText>
                    <FlexContainer>
                      <Controller
                        defaultValue={""}
                        color={errors.childeren ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name={data.type}
                        placeholder={data.name ? data.name : getByLabelText(data.type)}
                        rules={{
                          required: data.required && 'This Field is required'
                        }}
                        as={
                          data.type === 'INPUT_NUMBER' ?
                            <NumberFormat minLength={1} allowNegative={false} decimalScale={0} />
                             : data.type === 'INPUT_ALPHA_NUMERIC' ? 
                             <Input onInput={OnInput} maxLength={254} type="text" /> : <Input type="text" />
                        }
                        customInput={Input} style={
                          {
                            marginTop: "0px",
                            marginBottom: "0px",
                            width: "299px",
                            borderRadius: "0px 0px 4px 4px",
                          }
                        }
                      />
                    </FlexContainer>
                    <ErrorMessage
                      errors={errors}
                      name={data.type}
                      render={({ message }) => (
                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                      )}
                    />
                  </div>
                </div>
                  )
                }
                </>
              ))
            }
          </>
        )
      }
    </>
  )
};


export default MetaData;
